import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import { EQUIPMENT } from 'constants/equipment'

export const getEquipment = ({
  trailerType,
}: Pick<BookableShipmentSavedSearch, 'trailerType'>): string => {
  if (!trailerType) {
    return 'Any Equipment'
  }

  const equipment = EQUIPMENT.find(e => e.key === trailerType)

  const { name: equipmentName = '' } = equipment || {}
  return equipmentName
}
